import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtUser } from "server/models"
import { EDIT } from "const"
import { hasProjectAccess } from "client/utils"
import {
    PRM_TEAM,
    StoreType,
    addModal,
} from "client/store"
import {
    UserIcon,
    TableColumn,
    TablePopover,
    TablePopoverData,
} from "client/components"

import AssignedGroups from "../groups/assigned"

const Columns = () => {
    const groupList = useSelector((state: StoreType) => state.projectGroup.groupList)
    const userGroupList = useSelector((state: StoreType) => state.projectUserGroup.userGroupList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editAccess = hasProjectAccess(PRM_TEAM, EDIT)
    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "firstName",
            header: lang.name,
            sortable: true,
            cellMinWidth: "200px",
            formatter: (user: MtUser) => <UserIcon user={user} size="sm" />,
        },
        {
            field: "groups",
            header: lang.groups,
            cellMinWidth: "200px",
            formatter: (user: MtUser) => {
                const groupIds = (userGroupList && userGroupList[user.id]) || []
                const dataList: TablePopoverData[] = []
                groupIds.forEach((groupId) => {
                    const group = groupList[groupId]
                    if (group) {
                        dataList.push({
                            id: `${user.id}_${group.groupId}`,
                            title: group.name,
                        })
                    }
                })

                return (
                    <TablePopover
                        id={`userGroups${user.id}`}
                        dataList={dataList}
                        placement="left"
                        title={lang.groups}
                        editAccess={editAccess}
                        onClick={() => dispatch(addModal({
                            key: "assignedGroups",
                            content: <AssignedGroups user={user} />,
                        }))}
                    />
                )
            },
        },
        {
            field: "status",
            header: lang.status,
            centerAlign: true,
            sortable: true,
            editAccess: () => false,
        },
    ]

    if (editAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
